import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Meetingph from "../../assets/pic/meeting.jpg"
import {Helmet} from "react-helmet";

const MeetingEn = ()=>{
    return(
        <div className='meeting-wrap'>
            <Helmet>
                <title>Online meetings</title>
                <meta name="description" content="There are many advantages to holding meetings virtually (web conferencing). One could say that its most important advantage is that there is no need for a specific place to hold the meeting which will result in reduced travel costs and, consecutively, results in saving time and money." />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>Holding meetings and associations </h1>
                <img src={Meetingph} alt="online meeting"/>
                <p>
                    There are many advantages to holding meetings virtually (web conferencing). One could say that its most important advantage is that there is no need for a specific place to hold the meeting which will result in reduced travel costs and, consecutively, results in saving time and money.
                </p>
                <p>
                    For instance, suppose that two scientific associations based in two different cities need to consult one another and cooperate. Determining a time and place for the meeting and coordination with all the members could be one of the main challenges for holding the meeting, while you could easily hold your meetings online (virtually) with great efficiency in platforms with the required and standard interactive tools.
                </p>
                <p>
                    Online (virtual) activity will place a bigger world before you. For instance, outsourcing projects to those meeting the required conditions in other cities or even countries could be carried out online. According to the results of social research in the field of technology and careers, people (whether employees or employers) are getting increasingly interested in working from home.
                </p>
                <p>
                    This increasing tendency is due to the advancements in communication technologies and evolution of the online meeting platforms. Today, online meeting platforms hold the most advanced interactive tools that could even result in higher efficiency compared to face-to-face meetings.
                </p>
                <p>
                    The standard interactive tools in an online meeting platform are as follows:
                </p>
                <ul>
                    <li>•	High-quality audio interaction</li>
                    <li>•	High-quality video interaction with the possibility of multiple video connections</li>
                    <li>•	Playing videos online </li>
                    <li>•	Text conversation and interaction (chatting)</li>
                    <li>•	Sharing files</li>
                    <li>•	Sharing desktops</li>
                    <li>•	The possibility of displaying important announcements or messages in the meeting environment periodically</li>
                </ul>
                <p>
                    BellMeet comprehensive online meeting platform is the only knowledge-based and native platform with the most advanced interactive tools mentioned above and is prepared to host your online meetings and seminars to provide you with a pleasant and more efficient experience compared to face-to-face meetings.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default MeetingEn